module.exports = __webpack_public_path__ + "static/bliss-17b785ff9974e876c020640e1ee4314d.jpg";